// extracted by mini-css-extract-plugin
export default {"modal-backdrop":"Modal_modal-backdrop__RR5M8","modal":"Modal_modal__LMAZX"};